<template>
    <div class="relative w-full">
        <span
            class="absolute -ml-px h-full w-0.5 bg-gray-dark rounded"
            aria-hidden="true"
        ></span>
        <div class="p-4 space-y-2">
            <div
                v-for="(query, index) in queries"
                :key="'or-query-' + index"
                class="space-y-2"
            >
                <div v-if="index > 0">
                    <span class="query-joiner">OR</span>
                </div>
                <div class="flex items-center space-x-2 w-full">
                    <automation-query
                        class="flex-1"
                        :query="query"
                        :options="options"
                        @change="syncQuery(index, $event)"
                    ></automation-query>
                    <button
                        class="rounded-full px-2 py-1 font-bold text-xs text-destructive"
                        @click.prevent="removeQuery(index)"
                        v-if="index > 0"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'times']"
                        ></font-awesome-icon>
                    </button>
                </div>
            </div>
            <div>
                <button class="query-joiner" @click.prevent="addAnotherQuery">
                    + OR
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        query: {
            type: Array,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        query() {
            this.reset();
        },
    },
    mounted() {
        this.emitChange();
    },
    data() {
        return {
            queries: this.query.length ? this.query : [this.makeNewQuery()],
        };
    },
    methods: {
        reset() {
            this.queries = this.query;
        },
        removeQuery(index) {
            this.queries.splice(index, 1);
            this.emitChange();
        },
        addAnotherQuery() {
            this.queries.push(this.makeNewQuery());
            this.emitChange();
        },
        syncQuery(index, $event) {
            this.$set(this.queries, index, $event);
            this.emitChange();
        },
        makeNewQuery() {
            return {
                attribute: "address",
                operator: "equals_to",
                value: this.options["address"],
            };
        },
        emitChange() {
            this.$emit("change", this.queries);
        },
    },
};
</script>

<style scoped>
span.query-joiner {
    @apply rounded-full px-2 py-1 font-bold text-xs;
}
button.query-joiner {
    @apply bg-primary-lighter text-primary rounded-full px-2 py-1 font-bold text-xs;
}
</style>
